import api from '../../lib/CfcLmsApi'
import documentServiceApi from '../../lib/DocumentServiceApi'
import actions from './actions'
import { addNotification } from '../notifications'
import { createTrainingReportDownloadData } from './selectors'

const fetchLessonProgressReport = (siteId, skuCode) => {
  return async dispatch => {
    dispatch(actions.fetchingReport(skuCode))
    try {
      const programCode = skuCode === 'K8P' ? 'K8' : 'HS'
      const response = await documentServiceApi.post('/SiteReport', {
        siteId,
        program: programCode,
      })
      const sasUrl = response.data.sasUrl
      dispatch(actions.fetchingReportSuccess(skuCode, sasUrl))
    } catch (error) {
      dispatch(actions.fetchingReportError(error, skuCode))
      dispatch(
        addNotification({
          color: 'danger',
          text: 'Failed to get Lesson Progress Report',
        }),
      )
    }
  }
}

const deleteReports = () => {
  return async dispatch => {
    dispatch(actions.deleteReportsSuccess())
  }
}

const fetchTrainingReport = (learners, program, siteName) => {
  return async dispatch => {
    dispatch(actions.fetchingReport(program))
    try {
      const { data: trainingReportData } = await api.getTrainingReport(
        learners,
        program.toLowerCase(),
      )
      const formattedTrainingReportData = createTrainingReportDownloadData(
        trainingReportData,
        program,
        siteName,
      )
      dispatch(
        actions.fetchingReportSuccess(program, formattedTrainingReportData),
      )
    } catch (error) {
      dispatch(actions.fetchingReportError(error))
      dispatch(
        addNotification({
          color: 'danger',
          text: error,
        }),
      )
    }
  }
}

export default {
  deleteReports,
  fetchLessonProgressReport,
  fetchTrainingReport,
}



// WEBPACK FOOTER //
// ./src/redux/reports/operations.js